// extracted by mini-css-extract-plugin
export var option = "PricingPanel-module__option___4frcT";
export var optionMargin = "PricingPanel-module__optionMargin___b1B2m";
export var optionsGroups = "PricingPanel-module__optionsGroups___oItFa";
export var verticallyAligned = "PricingPanel-module__verticallyAligned___m-RPc";